import { createSlice } from "@reduxjs/toolkit";

const ChatDQPSlice = createSlice({
  name: "ChatDQP",
  initialState: {
    open: false,
  },
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
  },
});

export const { setOpen } = ChatDQPSlice.actions;
export default ChatDQPSlice.reducer;
